function toggleShownText(e) {
    const mainContainer = e.target.closest(".new-custom-image-long-text");
    if(!mainContainer) return;

    const longText = mainContainer.querySelector(".new-custom-long-text");
    const expandBtn = mainContainer.querySelector(".expand-button");
    const fadeOverlay = mainContainer.querySelector(".fade-overlay");

    if(!longText || !expandBtn || !fadeOverlay) return;

    longText.classList.toggle("collapsed");
    expandBtn.classList.toggle("collapsed");
    fadeOverlay.classList.toggle("hidden");
}